import { RootReducer } from '../redux/rootReducer'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

interface Props {
  canvasRef: React.RefObject<HTMLCanvasElement>
}

const CanvasLines = ({ canvasRef }: Props) => {
  const lines = useSelector((state: RootReducer) => state.slidesReducer.lines)

  useEffect(() => {
    if (canvasRef.current) {
      const canvas = canvasRef.current
      const context = canvas.getContext('2d')
      if (context) {
        context.clearRect(0, 0, canvas.width, canvas.height)
        const dpr = window.devicePixelRatio || 1
        canvas.width = canvas.clientWidth * dpr
        canvas.height = canvas.clientHeight * dpr
        context.scale(dpr, dpr)

        lines.forEach((line) => {
          if (line.length > 1) {
            context.beginPath()
            context.strokeStyle = 'red'
            context.lineWidth = 2
            context.moveTo(line[0].x, line[0].y)

            line.forEach((point) => {
              context.lineTo(point.x, point.y)
            })

            context.stroke()
            context.closePath()
          }
        })
      }
    }
  }, [lines, canvasRef])

  return <></>
}

export default CanvasLines
